// extracted by mini-css-extract-plugin
export var button = "styles-module--button--fbe43";
export var container = "styles-module--container--1e586";
export var content = "styles-module--content--c1e0f";
export var description = "styles-module--description--c24a5";
export var image = "styles-module--image--c665a";
export var name = "styles-module--name--6a9a8";
export var price = "styles-module--price--1c752";
export var priceSuffix = "styles-module--priceSuffix--85836";
export var tesla = "styles-module--tesla--10059";
export var titles = "styles-module--titles--a9219";
export var type = "styles-module--type--97ed9";